<template>
	<popup title="Select a payment method to add" @close="$emit('close')">
		<template v-slot:content>
		<div class="gateways_popup" >
				<div >
					<!--	        if COD -->
					<div class="alarm_panel green" v-if="currentGroup.id === 3">
						<div class="icon_wrpr">
							<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" data-icon="question-circle" data-prefix="fas" id="ember2262" class="svg-inline--fa fa-question-circle fa-w-16 fa-4x  undefined ember-view">
								<path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"></path>
							</svg>
						</div>
						<p>Cash on delivery sales are handled by Funnelish™, you can use automations within Funnelish™
							to automate your orders fulfilment process.</p>
					</div>

					<p>Now, which payment processor you'd like to associate with the selected payment method?</p>

					<div class="payment-options-container" :class="{'round':currentGroup.id === 3}"
					     v-if="currentGroup.user_gateways && currentGroup.user_gateways.length>0">
						<gateway-entry v-for="(userGateway, gIndex) in currentGroup.user_gateways" :key="gIndex"
						               :current-group="currentGroup" :user-gateway="userGateway"
						               @editUserGateway="editUserGateway" @deleteGateway="deleteGateway" @gatewayClicked="gatewayClicked"/>
					</div>

					<!--	        Add new gateway if not COD -->
					<a @click="$emit('addNew')" class="btn wide_btn bottom-entry"
					   :class="{'round':!currentGroup.user_gateways || !currentGroup.user_gateways.length}"
					   v-if="currentGroup.id !== 3">{{currentGroup.add_new}}</a>

					<p v-if="currentGroup.id === 3">* You can't add new Cash On Delivery gateways.</p>
					<p v-else>* Feel free to add a new payment gateway if needed.</p>
				</div>

			</div>
		</template>
		<template v-slot:actions>
			<v-button @click="$emit('goBack')" border >Back</v-button>
			<v-button @click="$emit('close')" border >Cancel</v-button>
		</template>
	</popup>
</template>

<script>
import VButton from "@/components/base/v-button";
import VSpinner from "@/components/base/v-spinner";
import API from "@/api";
import InputField from "@/components/base/input-field";
import Popup from "@/components/base/popup";
import GatewayEntry from "@/views/funnels/apps/funnel-apps/fpay/gateway-entry";

export default {
	name: "fpay-group-gateways-popup",
	components: {GatewayEntry, Popup, InputField, VSpinner, VButton},
	props: ['currentGroup', 'newGatewayConfig', 'creatingNew'],
	mixins: [API],

	data: function (){
		return {
			deleting: false,
		}
	},
	methods:{
		editUserGateway(userGateway) {
			// propragate event
			this.$emit('editUserGateway', userGateway)
		},
		async deleteGateway(userGateway) {
			// propragate event
			this.$emit('deleteGateway', userGateway)
		},
		gatewayClicked(userGateway) {
			this.$emit('gatewayClicked', userGateway)
		},
	}
}
</script>

<style lang="scss" scoped>
.round {
	border-radius: 5px !important;
}
</style>
